import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISChartComponent } from './is-chart.component';
import { SharedModule } from '../shared.module';

@NgModule({
    declarations: [
        ISChartComponent
    ],
    imports: [
        CommonModule,
        SharedModule
    ],
    exports: [
        ISChartComponent
    ],
    providers: [],
})
export class ISChartModule {}